/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: VqaN_WL-stA

import * as React from "react";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import ListSectionHeader from "../../components/ListSectionHeader"; // plasmic-import: wNvxk7eOak/component
import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import NavButton from "../../components/dashboard/NavButton"; // plasmic-import: 82ZzbE4hazN/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicNavSection.module.css"; // plasmic-import: VqaN_WL-stA/css

import VariantGroupIcon from "../plasmic_kit/PlasmicIcon__VariantGroup"; // plasmic-import: pyS6pK4Spx-QF/icon
import PlusCircleSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__PlusCircleSvg"; // plasmic-import: tPPI666-2/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon
import ArrowRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowRightSvg"; // plasmic-import: 9Jv8jb253/icon

createPlasmicElementProxy;

export type PlasmicNavSection__VariantMembers = {};
export type PlasmicNavSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicNavSection__VariantsArgs;
export const PlasmicNavSection__VariantProps = new Array<VariantPropType>();

export type PlasmicNavSection__ArgsType = {
  name?: string;
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicNavSection__ArgsType;
export const PlasmicNavSection__ArgProps = new Array<ArgPropType>(
  "name",
  "children"
);

export type PlasmicNavSection__OverridesType = {
  root?: Flex__<"div">;
  listSectionHeader?: Flex__<typeof ListSectionHeader>;
  text?: Flex__<"div">;
};

export interface DefaultNavSectionProps {
  name?: string;
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicNavSection__RenderFunc(props: {
  variants: PlasmicNavSection__VariantsArgs;
  args: PlasmicNavSection__ArgsType;
  overrides: PlasmicNavSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", sty.freeBox__vefYm)}>
        {(() => {
          try {
            return $props.name;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return true;
            }
            throw e;
          }
        })() ? (
          <ListSectionHeader
            data-plasmic-name={"listSectionHeader"}
            data-plasmic-override={overrides.listSectionHeader}

            className={classNames("__wab_instance", sty.listSectionHeader)}
          >
            <div
              data-plasmic-name={"text"}
              data-plasmic-override={overrides.text}

              className={classNames("all", "__wab_text", sty.text)}
            >
              <React.Fragment>{$props.name}</React.Fragment>
            </div>
          </ListSectionHeader>
        ) : null}
        <div className={classNames("all", sty.freeBox___0Gz4N)}>
          {renderPlasmicSlot({
            defaultContents: (
              <React.Fragment>
                <NavButton
                  className={classNames("__wab_instance", sty.navButton__hvjq)}
                />

                <NavButton
                  className={classNames("__wab_instance", sty.navButton__cfHjl)}
                />

                <NavButton
                  className={classNames("__wab_instance", sty.navButton__lSr1C)}
                >
                  {"Button"}
                </NavButton>
              </React.Fragment>
            ),
            value: args.children
          })}
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "listSectionHeader", "text"],
  listSectionHeader: ["listSectionHeader", "text"],
  text: ["text"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  listSectionHeader: typeof ListSectionHeader;
  text: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNavSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNavSection__VariantsArgs;
    args?: PlasmicNavSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicNavSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNavSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNavSection__ArgProps,
          internalVariantPropNames: PlasmicNavSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNavSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNavSection";
  } else {
    func.displayName = `PlasmicNavSection.${nodeName}`;
  }
  return func;
}

export const PlasmicNavSection = Object.assign(
  // Top-level PlasmicNavSection renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    listSectionHeader: makeNodeComponent("listSectionHeader"),
    text: makeNodeComponent("text"),

    // Metadata about props expected for PlasmicNavSection
    internalVariantProps: PlasmicNavSection__VariantProps,
    internalArgProps: PlasmicNavSection__ArgProps
  }
);

export default PlasmicNavSection;
/* prettier-ignore-end */
